import { FarmnetModuleService } from '../../angular/routing/services/farmnet-module.service';

ModuleLoaderDirective.$inject = ['$compile', '$parse', 'farmnetModuleService'];

export function ModuleLoaderDirective($compile, $parse, farmnetModuleService: FarmnetModuleService) {
    return {
        restrict: 'E',
        link: function(scope, element, attrs) {
            let loadModule: string[] = attrs.loadModule.split(',');
            let modulesToLoad: string[] = [];

            modulesToLoad = loadModule.filter((moduleName) => farmnetModuleService.hasModule(moduleName));

            if (loadModule.length !== modulesToLoad.length) {
                console.warn('module not found', loadModule.filter((moduleName) => !farmnetModuleService.hasModule(moduleName)))
            }

            let html = '<div oc-lazy-load=' + JSON.stringify(modulesToLoad) + '>';
            let innerHtml = element.html();
            element.html('');
            element.append(html + innerHtml + '</div>');
            $compile(element.contents())(scope);
        }
    };
}
